// removed by extract-text-webpack-plugin
module.exports = {"card":"Card__card___yFGQ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Card/Card.scss
// module id = 1631
// module chunks = 0